module.exports = __webpack_public_path__ + "static/img/ecmedia2.bc0ea74b.png";